import React, { Component } from 'react'

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { reduxForm, Field, formValueSelector, Form } from 'redux-form'

import renderSelectInput from '../../../../components/ui/forms/renderSelectInput'
import renderTextInputWithFeedback from '../../../../components/ui/forms/renderTextInputWithFeedback'
import fullstory from '../../../../utils/constants/fullstory'
import renderCheckbox from '../../../../components/ui/forms/renderCheckbox'
import LocationSearchBoxWithSuggestions from '../../../../components/ui/forms/LocationSearchBoxWithSuggestions'
import formValidators from '../../../../utils/validation/formValidators'

class JobSearchFiltersForm extends Component {
  static propTypes = {
    isEmptyData: PropTypes.bool,
    isLoading: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      showClearFilterPrompt: false,
    }

    this.checkNoDataWithFilter = () => {
      const { isEmptyData, payFilter, payValue } = this.props

      const { showClearFilterPrompt } = this.state

      if (isEmptyData && payValue && payValue === payFilter && !showClearFilterPrompt) {
        this.setState({ showClearFilterPrompt: true })
      } else if ((!isEmptyData || payValue !== payFilter) && showClearFilterPrompt) {
        this.setState({ showClearFilterPrompt: false })
      }
    }

    this.normalizeRadius = value => {
      if (!value || !value.length) return 0
      if (typeof value === 'string') return parseInt(value, 10)

      return value
    }
  }

  componentDidMount() {
    this.checkNoDataWithFilter()
  }

  componentDidUpdate() {
    this.checkNoDataWithFilter()
  }

  render() {
    const { isLoading, onSubmit, handleSubmit, locationValue } = this.props

    return (
      <Form onSubmit={handleSubmit(onSubmit)}>
        <div id="jobSearch">
          <div className="row align-items-center">
            <div className="col-md-12">
              <Field
                className={`LoNotSensitive ${fullstory.classNames.textInput}`}
                name="searchTerm"
                component={renderTextInputWithFeedback}
                label="Keywords (required)"
                placeholder="software engineer, teacher..."
              />
            </div>

            <div className="col-sm-12 col-md-12 col-12">
              <Field
                className={`LoNotSensitive ${fullstory.classNames.textInput}`}
                name="location"
                component={LocationSearchBoxWithSuggestions}
                label="Location"
                placeholder="City, State or ZIP"
                shadow={false}
                style={{ marginBottom: '1em' }}
                onSuggestionSelected={suggestion => {
                  this.props.change('location', suggestion.description)
                }}
              />
            </div>
            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4">
              <Field
                onChange={e => this.props.change('radius', e.target.value)}
                name="radius"
                normalize={this.normalizeRadius}
                label="Radius"
                component={renderSelectInput}
                disabled={!locationValue || !locationValue.length}
                options={[
                  { displayName: 'Within 5 Miles', value: 5 },
                  { displayName: 'Within 10 Miles', value: 10 },
                  { displayName: 'Within 25 Miles', value: 25 },
                  { displayName: 'Within 50 Miles', value: 50 },
                  { displayName: 'Within 100 Miles', value: 100 },
                ]}
              />
            </div>
            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4">
              <Field
                className="LoNotSensitive"
                name="workFromHome"
                label="Include Remote Jobs"
                component={renderCheckbox}
              />
            </div>
            <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4 ">
              {isLoading ? (
                <h6 style={{ margin: 0, padding: '10px 0' }}>Loading...</h6>
              ) : (
                <button
                  className="btn btn-primary"
                  type="submit"
                  style={{ padding: '10px 0', width: '100%' }}
                >
                  Search
                </button>
              )}
            </div>
          </div>
        </div>
      </Form>
    )
  }
}

const validate = values => {
  const { searchTerm, location } = values
  let errors = {}
  errors.searchTerm = formValidators.isRequired(searchTerm)
    ? formValidators.isRequired(searchTerm)
    : formValidators.maxLengthTwoHundred(searchTerm)

  errors.location = formValidators.maxLengthTwoHundred(location)

  return errors
}

const jobSearchForm = reduxForm({
  form: 'jobSearchFiltersForm',
  validate,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(JobSearchFiltersForm)

// Decorate with connect to read form values
const selector = formValueSelector('jobSearchFiltersForm') // <-- same as form name

const jobSearchFormWithRedux = connect(state => {
  const locationValue = selector(state, 'location')
  return {
    locationValue,
  }
})(jobSearchForm)

export default jobSearchFormWithRedux



// WEBPACK FOOTER //
// ./src/routes/authenticated/JobSearch/components/JobSearchFiltersForm.js